export const CREATE_WORKER_JAMA = 'CREATE_WORKER_JAMA';
export const GET_WORKER_JAMA = 'GET_WORKER_JAMA';
export const WORKER_JAMA_REQUEST = 'WORKER_JAMA_REQUEST';
export const UPDATE_WORKER_JAMA = 'UPDATE_WORKER_JAMA';
export const DELETE_WORKER_JAMA = 'DELETE_WORKER_JAMA';
export const WORKER_JAMA_REQUEST_FAILURE = 'WORKER_JAMA_REQUEST_FAILURE';
export const JAMA_KARIGAR_REQUEST = 'JAMA_KARIGAR_REQUEST';
export const GET_JAMA_KARIGARS = 'GET_JAMA_KARIGARS';
export const JAMA_KARIGAR_REQUEST_FAILURE = 'JAMA_KARIGAR_REQUEST_FAILURE';